import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center mb-6" }
const _hoisted_2 = { class: "md:w-3/5 w11/12 relative" }
const _hoisted_3 = { class: "border-2 border-solid border-gray-300 border-opacity-30 p-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_5 = { class: "w-3/5 flex flex-col justify-start items-start" }
const _hoisted_6 = { class: "w-2/5 flex justify-end" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "flex justify-center items-center"
}
const _hoisted_9 = { class: "w-2/5 flex justify-start" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "w-3/5 flex flex-col items-start" }
const _hoisted_12 = { class: "relative w-full h-full hidden md:block" }
const _hoisted_13 = { class: "flex flex-col text-orange-300 text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRight)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "md:w-1/12 hidden md:block" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: require('@/assets/' + _ctx.imageName + ''),
                  alt: "",
                  class: "w-3/4 aspect-auto image-shadow rounded-md"
                }, null, 8, _hoisted_7)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: require('@/assets/' + _ctx.imageName + ''),
                  alt: "",
                  class: "w-3/4 aspect-auto image-shadow md:rounded-md rounded-sm"
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "md:w-1/12 hidden md:block" }, null, -1))
            ])),
        _createElementVNode("div", {
          class: _normalizeClass(["absolute top-2 left-2", { 'right-2': !_ctx.isRight, 'text-right': !_ctx.isRight }])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_component_fa, {
                    key: n,
                    icon: ['far', 'star']
                  })
                }), 64))
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createElementVNode("div", { key: n }, [
                  _createVNode(_component_fa, { icon: ['far', 'star'] })
                ])
              }), 64))
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}